/* Carry the Studio quantity into the existing product form once. */
(function () {
  'use strict';
  const params = new URLSearchParams(location.search);
  const quantity = Number(params.get('hyfen_quantity'));
  if (!params.has('hyfen_country_1') || !params.has('hyfen_country_2') ||
      !params.has('hyfen_style') || !Number.isInteger(quantity) || quantity < 1 || quantity > 10) return;
  let applied = false;
  const apply = () => {
    if (applied) return;
    const inputs = [...document.querySelectorAll('product-form-component input[name="quantity"], form[action*="/cart/add"] input[name="quantity"]')];
    if (!inputs.length) return;
    // Stop observing before dispatching changes; subsequent customer edits win.
    applied = true; observer.disconnect(); clearTimeout(timeout);
    for (const input of inputs) {
      const min = Number(input.min) || 1;
      const max = input.max ? Number(input.max) : 10;
      const step = Number(input.step) || 1;
      input.value = String(Math.max(min, Math.min(max, min + Math.floor((quantity-min)/step)*step)));
      input.dispatchEvent(new Event('input', {bubbles:true}));
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }
    const clean = new URL(location.href); clean.searchParams.delete('hyfen_quantity');
    history.replaceState(null, '', clean.pathname + clean.search + clean.hash);
  };
  const observer = new MutationObserver(apply);
  const timeout = setTimeout(() => observer.disconnect(), 20000);
  observer.observe(document.documentElement, {childList:true, subtree:true});
  apply();
})();
